import React, { useEffect, useState } from 'react';
import {
  BenchmarkContainer,
  BenchmarkScoreWrapper,
  BenchmarkTitleContainer,
  ButtonsDetailContainer,
  ButtonWithIcon,
  DetailsHeaderContainer,
  SectionDetail,
  SectionName,
  SectionWrapper,
} from './styled.myAuditDetails';
import { Headline3 } from '../../../common/typography';
import { useTranslation } from 'react-i18next';
import { ExpandableCard } from '../../../myAudit/components/ExpandableCard';
import { Image } from './../../../common/icons/Image';
import { Voice } from './../../../common/icons/Voice';
import { defaultTheme } from './../../../styles/theme/default';
import {
  ColumnItem,
  IDetailsSections,
  IMyAuditDetailsResponse,
} from './../../../@types/detailsPage';
import { DetailSkeleton } from './../../MyAuditSkeleton/DetailSkeleton';
import { getMyAuditDetails } from '../../../../requests/myAudit';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { showErrorMessage } from '../../../../helpers/showMessage';
import { sentryReport } from '../../../../helpers/sentry';
import {
  HeaderContainer,
  StyledMyAuditContainer,
} from '../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';

export function MyAuditDetails () {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const auditId = Number(searchParams.get('auditId')) || 0;
  const [detailsData, setDetailsData] = useState<IMyAuditDetailsResponse>();
  const myAuditViewPageLink = (myAuditId: string, sectionId: number) =>
    navigate(`/myaudit/view?auditId=${myAuditId}&sectionId=${sectionId}`);

  useEffect(() => {
    getMyAuditDetails(auditId)
      .then((response) => {
        setDetailsData(response.data);
      })
      .catch((error) => {
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_MY_AUDIT_DETAILS')
        );
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t(
            'COMMON.ALERTS_MESSAGES.UNABLE_TO_GET_MY_AUDIT_DETAILS'
          ),
          path: '/myaudit/details/${auditId}',
        });
      });
  }, []);

  const detailPageColumns: ColumnItem[] = [
    detailsData && detailsData.templateName,
  ];

  // TODO This will be added back when we have clarified the usage of the filter and have the API for it.
  // const dropdownOptions: IDropdownOption[] = [
  //   {value: 'Performance', label: 'Performance'},
  //   {value: 'Service', label: 'Service'},
  //   {value: 'Efficiency', label: 'Efficiency'},
  //   {value: 'Cleanliness', label: 'Cleanliness'},
  //   {value: 'Product', label: 'Product'},
  //   {value: 'Sales', label: 'Sales'},
  //   {value: 'Food', label: 'Food'},
  //   {value: 'Sustainability', label: 'Sustainability'},
  // ];

  return (
    <>
      <HeaderContainer>
        <AppHeader title={t('COMMON.MY_AUDIT.TITLE')} />
      </HeaderContainer>
      <StyledMyAuditContainer>
        <>
          <DetailsHeaderContainer>
            <Headline3>{t('COMMON.MY_AUDIT.DETAILS.TITLE')}</Headline3>
            {/*//TODO This will be added back when we have clarified the usage of the filter and have the API for it.*/}
            {/*<FilterContainer>*/}
            {/*  <DropdownSingle*/}
            {/*    options={dropdownOptions}*/}
            {/*    callback={() => {*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</FilterContainer>*/}
          </DetailsHeaderContainer>

          {detailsData && (
            <>
              <BenchmarkContainer>
                <BenchmarkTitleContainer>
                  <Headline3>{detailsData.templateName}</Headline3>
                </BenchmarkTitleContainer>
                <Headline3>{Number(detailsData.score).toFixed(0)}%</Headline3>
              </BenchmarkContainer>
              <ExpandableCard
                columns={detailPageColumns}
                backgroundColorDetail="seasalt"
              >
                {detailsData.sections &&
                  detailsData.sections.map(
                    (
                      {
                        sectionName,
                        score,
                        hasImage,
                        hasAudio,
                        sectionId,
                      }: IDetailsSections,
                      index
                    ) => (
                      <SectionWrapper key={`${index}-${sectionName}`}>
                        <SectionDetail>
                          <SectionName
                            onClick={() =>
                              myAuditViewPageLink(
                                detailsData!.myAuditId,
                                sectionId
                              )
                            }
                          >
                            {sectionName}
                          </SectionName>
                          <div>
                            <BenchmarkScoreWrapper>
                              {Number(score).toFixed(0)}%
                            </BenchmarkScoreWrapper>
                          </div>
                        </SectionDetail>
                        <ButtonsDetailContainer>
                          {hasAudio && (
                            <ButtonWithIcon
                              onClick={() =>
                                myAuditViewPageLink(
                                  detailsData!.myAuditId,
                                  sectionId
                                )
                              }
                              borderColor={
                                defaultTheme.colorsInObjects.mint[900]
                              }
                              backgroundColor="white"
                            >
                              <Voice strokeColor="verdigris" />
                            </ButtonWithIcon>
                          )}
                          {hasImage && (
                            <ButtonWithIcon
                              onClick={() =>
                                myAuditViewPageLink(
                                  detailsData!.myAuditId,
                                  sectionId
                                )
                              }
                              borderColor={
                                defaultTheme.colorsInObjects.mint[900]
                              }
                              backgroundColor="white"
                            >
                              <Image strokeColor="verdigris" />
                            </ButtonWithIcon>
                          )}
                        </ButtonsDetailContainer>
                      </SectionWrapper>
                    )
                  )}
              </ExpandableCard>
            </>
          )}
        </>
        {!detailsData && <DetailSkeleton />}
      </StyledMyAuditContainer>
    </>
  );
}
